/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-console */
/* eslint-disable import/no-cycle */
import { ReloadOutlined } from '@ant-design/icons';
import { IconCrown, IconExportExcel, IconSearch } from '@assets/icons';
import {
  ANALYTIC_INDEPTH_MODE,
  ANALYTIC_LIST_MODE,
  FILTER_PICKER_MODE,
  FILTER_PICKER_RANGE_MODE,
} from '@common/constant/mode';
import {
  COMPANY_OPTION_PREFIX,
  LAYOUT_OPTION_PREFIX,
} from '@common/constant/option';
import {
  TABLE_PAGE_NUMBER,
  TABLE_PAGE_SIZE,
  TABLE_SORT_ASC,
  TABLE_SORT_DESC,
} from '@common/constant/table';
import { ANALYTIC_DETAIL_MODE } from '@common/constant/fab';
import useFetch from '@common/hooks/useFetch';
import { getDateRangeSuffix } from '@common/utils/dateHelper';
import {
  getFilterConfigForComponent,
  isDepthMode,
  isMonthPickerMode,
} from '@common/utils/modeHelper';
import { processFilterOptions } from '@common/utils/optionFilterHelper';
import ComMonthPicker from '@components/common/ComMonthPicker';
import ComMonthSelector from '@components/common/ComMonthSelector';
import ComSwitch from '@components/common/ComSwitch';
import ComTable from '@components/common/ComTable';
import { fabAccessLogApi } from '@services/fabAccessLogApi';
import '@styles/pages/AnalyticDetail.scss';
import dayjs from 'dayjs';
import { saveAs } from 'file-saver';
import { t } from 'i18next';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { AnalyticContext } from '..';
import HorizontalChartModal from './HorizontalChartModal';
import PieChartModal from './PieChartModal';

// Helper function to convert "HH:MM:SS.mmm" to seconds
const playTimeToSeconds = (playTime) => {
  if (!playTime) return 0;
  const [time] = playTime.split('.');
  const [hours, minutes, seconds] = time.split(':').map(Number);
  return hours * 3600 + minutes * 60 + seconds;
};

function AnalyticDetail() {
  const [pagination, setPagination] = useState({
    page_number: TABLE_PAGE_NUMBER,
    page_size: TABLE_PAGE_SIZE,
    order: TABLE_SORT_ASC,
    user_ids: null,
    events_types: null,
    fab_ids: null,
    company_ids: null,
    from_date: null,
    to_date: null,
    order_by: 'no',
  });

  const [optionFilter, setOptionFilter] = useState([]);
  const [modeFilter, setModeFilter] = useState(FILTER_PICKER_MODE); // picker | picker_range
  const [accessHorizontalChart, setAccessHorizontalChart] = useState({
    open: false,
  });
  const [durationHorizontalChart, setDurationHorizontalChart] = useState({
    open: false,
  });
  const [accessPieChart, setAccessPieChart] = useState({
    open: false,
    selected: null,
  });
  const [durationPieChart, setDurationPieChart] = useState({
    open: false,
    selected: null,
  });

  const [topVisitsData, setTopVisitsData] = useState([]);
  const [topPlayTimesData, setTopPlayTimesData] = useState([]);
  const [shouldFetchTopVisits, setShouldFetchTopVisits] = useState(0);
  const [shouldFetchTopPlayTimes, setShouldFetchTopPlayTimes] = useState(0);
  const [topUserVisitsData, setTopUserVisitsData] = useState([]);
  const [topUserPlayTimesData, setTopUserPlayTimesData] = useState([]);
  const [shouldFetchTopUserVisits, setShouldFetchTopUserVisits] = useState(0);
  const [shouldFetchTopUserPlayTimes, setShouldFetchTopUserPlayTimes] =
    useState(0);
  const { mode, setMode, monthOptions, filterOptions } =
    useContext(AnalyticContext);

  const { loadingTable, value, reload } = useFetch(() => {
    if (!pagination.from_date || !pagination.to_date) {
      return null;
    }
    return fabAccessLogApi.getSummaryAccessLogs(pagination);
  }, [
    pagination.page_number,
    pagination.page_size,
    pagination.order,
    pagination.order_by,
    pagination.keyword,
    pagination.layout_ids,
    pagination.company_ids,
    pagination.from_date,
    pagination.to_date,
  ]);

  const { loadingTable: loadingTopVisits, value: topVisitsValue } =
    useFetch(() => {
      if (shouldFetchTopVisits === 0) {
        return null;
      }
      return fabAccessLogApi.getTopLayoutByTotalVisits({
        from_date: pagination.from_date,
        to_date: pagination.to_date,
        company_ids: pagination.company_ids,
        fab_ids: pagination.fab_ids,
      });
    }, [shouldFetchTopVisits]);

  const { loadingTable: loadingTopPlayTimes, value: topPlayTimesValue } =
    useFetch(() => {
      if (shouldFetchTopPlayTimes === 0) {
        return null;
      }
      return fabAccessLogApi.getTopLayoutByTotalPlayTimes({
        from_date: pagination.from_date,
        to_date: pagination.to_date,
        company_ids: pagination.company_ids,
        fab_ids: pagination.fab_ids,
      });
    }, [shouldFetchTopPlayTimes]);

  const { loadingTable: loadingTopUserVisits, value: topUserVisitsValue } =
    useFetch(() => {
      if (shouldFetchTopUserVisits === 0) {
        return null;
      }
      return fabAccessLogApi.getTopUserByTotalVisits({
        layout_id: accessPieChart.selected?.layout_id,
        from_date: pagination.from_date,
        to_date: pagination.to_date,
        company_ids: pagination.company_ids,
        fab_ids: pagination.fab_ids,
      });
    }, [shouldFetchTopUserVisits]);

  const {
    loadingTable: loadingTopUserPlayTimes,
    value: topUserPlayTimesValue,
  } = useFetch(() => {
    if (shouldFetchTopUserPlayTimes === 0) {
      return null;
    }
    return fabAccessLogApi.getTopUserByTotalPlayTimes({
      layout_id: durationPieChart.selected?.layout_id,
      from_date: pagination.from_date,
      to_date: pagination.to_date,
      company_ids: pagination.company_ids,
      fab_ids: pagination.fab_ids,
    });
  }, [shouldFetchTopUserPlayTimes]);

  useEffect(() => {
    const filterConfig = getFilterConfigForComponent(ANALYTIC_DETAIL_MODE);
    if (filterOptions && Object.keys(filterOptions).length > 0) {
      const allOptions = processFilterOptions(filterOptions);
      setOptionFilter(
        filterConfig.map((item) => ({
          ...item,
          children: allOptions[item.dataKey] || [],
        })),
      );
    } else {
      setOptionFilter(
        filterConfig.map((item) => ({
          ...item,
          children: [],
        })),
      );
    }
  }, [filterOptions]);

  useEffect(() => {
    if (topVisitsValue?.data) {
      const formattedData = topVisitsValue.data?.data?.map((item) => ({
        name: item.layout_name || '',
        company: item.company_name || '',
        value: item.access_count || 0,
      }));
      setTopVisitsData(formattedData);
    }
  }, [topVisitsValue]);

  useEffect(() => {
    if (topPlayTimesValue?.data) {
      const formattedData = topPlayTimesValue.data?.data?.map((item) => ({
        name: item.layout_name || '',
        company: item.company_name || '',
        value: playTimeToSeconds(item.total_play_time),
        displayValue: item.total_play_time?.split('.')[0] || '00:00:00',
      }));
      setTopPlayTimesData(formattedData);
    }
  }, [topPlayTimesValue]);

  useEffect(() => {
    if (topUserVisitsValue?.data) {
      const formattedData = topUserVisitsValue.data?.data?.map((item) => ({
        name: item.employee_code || '',
        value: item.access_count || 0,
      }));
      setTopUserVisitsData(formattedData);
    }
  }, [topUserVisitsValue]);

  useEffect(() => {
    if (topUserPlayTimesValue?.data) {
      const formattedData = topUserPlayTimesValue.data?.data?.map((item) => ({
        name: item.employee_code || '',
        value: playTimeToSeconds(item.total_play_time),
        displayValue: item.total_play_time?.split('.')[0] || '00:00:00',
      }));
      setTopUserPlayTimesData(formattedData);
    }
  }, [topUserPlayTimesValue]);

  const paginationProp = {
    position: ['bottomRight'],
    total: value?.data?.count,
    pageSize: pagination?.page_size,
    currentPage: pagination?.page_number,
  };

  const handleSearch = (values) => {
    setPagination({
      ...pagination,
      keyword: values,
      page_number: TABLE_PAGE_NUMBER,
    });
  };

  const handleChangePagination = (currentPage, pageSize) => {
    setPagination((curState) => ({
      ...curState,
      page_size: pageSize,
      page_number: currentPage,
    }));
  };

  const hanldeChangeTable = (_, filter, sorter) => {
    if (sorter?.order === 'descend') {
      setPagination({
        ...pagination,
        order: TABLE_SORT_DESC,
        order_by: sorter?.field,
      });
    } else {
      setPagination({
        ...pagination,
        order: TABLE_SORT_ASC,
        order_by: sorter?.field,
      });
    }
  };

  const onChangeTreeSelect = (dataSelect) => {
    const groups = {
      [COMPANY_OPTION_PREFIX]: [],
      [LAYOUT_OPTION_PREFIX]: [],
    };
    dataSelect.forEach((item) => {
      const [prefix, vId] = item.split('_');
      if (groups[prefix]) groups[prefix].push(Number(vId));
    });
    setPagination({
      ...pagination,
      company_ids:
        groups[COMPANY_OPTION_PREFIX].length > 0
          ? groups[COMPANY_OPTION_PREFIX].join(',')
          : null,
      layout_ids:
        groups[LAYOUT_OPTION_PREFIX].length > 0
          ? groups[LAYOUT_OPTION_PREFIX].join(',')
          : null,
      page_number: TABLE_PAGE_NUMBER,
    });
  };

  const filterTreeNode = (inputValue, treeNode) => {
    const title = treeNode?.props?.title.trim() || '';
    return title.toLowerCase().includes(inputValue.toLowerCase().trim());
  };

  const exportExcelFile = useCallback(
    async (dataExport) => {
      try {
        const fileData = await fabAccessLogApi.exportSummaryAccessLogs(
          dataExport,
        );
        const blob = new Blob([fileData], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const exportSuffix = getDateRangeSuffix(
          pagination.from_date,
          pagination.to_date,
          modeFilter,
          'YYYYMM',
        );
        saveAs(blob, `FaView_分析_${exportSuffix}.xlsx`);
      } catch (error) {
        console.error('Error exporting to Excel:', error);
      }
    },
    [pagination.from_date, pagination.to_date, modeFilter],
  );

  const handleModeChange = (switchValue) => {
    setMode(switchValue ? ANALYTIC_INDEPTH_MODE : ANALYTIC_LIST_MODE);
  };

  const handleFilterChange = (switchValue) => {
    setModeFilter(switchValue ? FILTER_PICKER_RANGE_MODE : FILTER_PICKER_MODE);
  };

  const handleMonthSelectorChange = useCallback((year, month) => {
    const parsedMonth = dayjs()
      .set('month', month - 1)
      .set('year', year);
    setPagination((prev) => ({
      ...prev,
      page_number: TABLE_PAGE_NUMBER,
      from_date: parsedMonth.startOf('month').format('YYYY-MM-DD'),
      to_date:
        year === dayjs().year() && month === dayjs().month() + 1
          ? dayjs().format('YYYY-MM-DD')
          : parsedMonth.endOf('month').format('YYYY-MM-DD'),
    }));
  }, []);

  const handleMonthPickerChange = useCallback((fromDate, toDate) => {
    setPagination((prev) => ({
      ...prev,
      page_number: TABLE_PAGE_NUMBER,
      from_date: dayjs(fromDate).startOf('month').format('YYYY-MM-DD'),
      to_date: dayjs(toDate).isSame(dayjs(), 'month')
        ? dayjs().format('YYYY-MM-DD')
        : dayjs(toDate).endOf('month').format('YYYY-MM-DD'),
    }));
  }, []);

  const handleViewAccessDetails = (record) => {
    setShouldFetchTopUserVisits((prev) => prev + 1);
    setAccessPieChart({ open: true, selected: record });
  };

  const handleViewTotalDurationDetails = (record) => {
    setShouldFetchTopUserPlayTimes((prev) => prev + 1);
    setDurationPieChart({ open: true, selected: record });
  };

  const handleShowAccessCountChart = () => {
    setShouldFetchTopVisits((prev) => prev + 1);
    setAccessHorizontalChart({ open: true });
  };

  const handleCloseAccessCountChart = () => {
    setTopVisitsData([]);
    setAccessHorizontalChart({ open: false });
  };

  const handleShowDurationChart = () => {
    setShouldFetchTopPlayTimes((prev) => prev + 1);
    setDurationHorizontalChart({ open: true });
  };

  const handleCloseDurationChart = () => {
    setTopPlayTimesData([]);
    setDurationHorizontalChart({ open: false });
  };

  const handleCloseAccessPieChart = () => {
    setTopUserVisitsData([]);
    setAccessPieChart({ open: false, selected: null });
  };

  const handleCloseDurationPieChart = () => {
    setTopUserPlayTimesData([]);
    setDurationPieChart({ open: false, selected: null });
  };

  const columns = [
    {
      title: t('analytic.detail.table.no'),
      dataIndex: 'no',
      key: 'no',
      width: 25,
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (values) => (
        <div className="display-flex jc-center">{values}</div>
      ),
    },
    {
      title: t('analytic.detail.table.companyName'),
      dataIndex: 'company_name',
      key: 'company_name',
      width: 120,
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (values) => <div className="display-flex">{values || '-'}</div>,
    },
    {
      title: t('analytic.detail.table.layoutName'),
      dataIndex: 'layout_name',
      key: 'layout_name',
      width: 120,
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (values) => <div className="display-flex">{values || '-'}</div>,
    },
    {
      title: (
        <div className="display-flex ai-center jc-space-btwn">
          <span>{t('analytic.detail.table.accessCount')}</span>
          <div
            className="icon-reload-wrapper pointer"
            onClick={(e) => {
              e.stopPropagation();
              handleShowAccessCountChart();
            }}
          >
            <IconCrown style={{ width: '28px', height: '28px' }} />
          </div>
        </div>
      ),
      dataIndex: 'access_count',
      key: 'access_count',
      width: 100,
      render: (values, record) => (
        <div className="display-flex jc-space-btwn ai-center">
          <div />
          <span>{values || 0}</span>
          <div
            className="icon-reload-wrapper pointer"
            onClick={() => {
              handleViewAccessDetails(record);
            }}
          >
            <IconSearch style={{ width: '28px', height: '28px' }} />
          </div>
        </div>
      ),
    },
    {
      title: (
        <div className="display-flex ai-center jc-space-btwn">
          <span>{t('analytic.detail.table.totalDuration')}</span>
          <div
            className="icon-reload-wrapper pointer"
            onClick={() => {
              handleShowDurationChart();
            }}
          >
            <IconCrown style={{ width: '28px', height: '28px' }} />
          </div>
        </div>
      ),
      dataIndex: 'total_play_time',
      key: 'total_play_time',
      width: 100,
      render: (values, record) => (
        <div className="display-flex jc-space-btwn ai-center">
          <div />
          <span>{values?.split('.')[0] || '00:00:00'}</span>
          <div
            className="icon-reload-wrapper pointer"
            onClick={() => {
              handleViewTotalDurationDetails(record);
            }}
          >
            <IconSearch style={{ width: '28px', height: '28px' }} />
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="fabs-list-wrapper full-width">
      <ComTable
        loading={loadingTable}
        columns={columns}
        data={value?.data?.data}
        pagination={paginationProp}
        onSearch={handleSearch}
        onChangeTable={hanldeChangeTable}
        onChangePagination={handleChangePagination}
        onChangeTreeSelect={onChangeTreeSelect}
        optionsTreeSelect={optionFilter}
        treeNodeFilterProp="title"
        filterTreeNode={filterTreeNode}
        isTreeSelect
        dataExport={pagination}
        buttonExport
        hideTitleBar
        showCustomBar
        customBar={
          <div className="title-header display-flex jc-space-btwn">
            <div className="display-flex item-center gap-8px">
              <span>{t('analytic.list.header.title')}</span>
              <ComSwitch
                defaultChecked={isDepthMode(mode)}
                onSwitchChange={handleModeChange}
              />
              <span>{t('analytic.list.header.log_list')}</span>
            </div>
            <div className="display-flex gap-8px">
              <div className="display-flex item-center gap-8px">
                <span>{t('analytic.list.header.specify_period')}</span>
                <ComSwitch onSwitchChange={handleFilterChange} />
                {isMonthPickerMode(modeFilter) ? (
                  <ComMonthSelector
                    options={monthOptions}
                    onMonthChange={handleMonthSelectorChange}
                  />
                ) : (
                  <ComMonthPicker
                    options={monthOptions}
                    onMonthChange={handleMonthPickerChange}
                  />
                )}
              </div>
              <div className="display-flex item-center gap-8px">
                <IconExportExcel
                  className="pointer"
                  onClick={() => exportExcelFile(pagination)}
                />
                <div
                  className="icon-reload-wrapper pointer"
                  onClick={() => reload()}
                >
                  <ReloadOutlined className="svg-icon-reload" />
                </div>
              </div>
            </div>
          </div>
        }
      />
      <HorizontalChartModal
        isVisible={accessHorizontalChart.open}
        onClose={handleCloseAccessCountChart}
        chartData={topVisitsData}
        isLoading={loadingTopVisits}
        pagination={pagination}
        pickerMode={modeFilter}
        monthOptions={monthOptions}
      />
      <HorizontalChartModal
        isVisible={durationHorizontalChart.open}
        onClose={handleCloseDurationChart}
        chartData={topPlayTimesData}
        isDurationChart
        isLoading={loadingTopPlayTimes}
        pagination={pagination}
        pickerMode={modeFilter}
        monthOptions={monthOptions}
      />
      <PieChartModal
        isVisible={accessPieChart.open}
        onClose={handleCloseAccessPieChart}
        chartData={topUserVisitsData}
        isLoading={loadingTopUserVisits}
        pagination={pagination}
        pickerMode={modeFilter}
        layoutName={accessPieChart.selected?.layout_name || ''}
        monthOptions={monthOptions}
      />
      <PieChartModal
        isDurationChart
        isVisible={durationPieChart.open}
        onClose={handleCloseDurationPieChart}
        chartData={topUserPlayTimesData}
        isLoading={loadingTopUserPlayTimes}
        pagination={pagination}
        pickerMode={modeFilter}
        layoutName={durationPieChart.selected?.layout_name || ''}
        monthOptions={monthOptions}
      />
    </div>
  );
}

export default AnalyticDetail;
